var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMt1 = function SvgMt1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 43,
    fill: "none",
    viewBox: "0 0 40 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2306_173568)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.427,
    d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5059C9",
    d: "M23.008 23.243v-4.468q0-.168.12-.286a.4.4 0 0 1 .292-.118h4.62a.79.79 0 0 1 .727.476.8.8 0 0 1 .06.296v4.1a2.8 2.8 0 0 1-.489 1.578 2.85 2.85 0 0 1-.8.783 2.9 2.9 0 0 1-1.61.479h-.021a2.95 2.95 0 0 1-2.05-.832 2.85 2.85 0 0 1-.793-1.454 2.8 2.8 0 0 1-.056-.554M27.8 15.52a1.8 1.8 0 0 1-.317 1.025 1.85 1.85 0 0 1-.845.679 1.9 1.9 0 0 1-1.088.105 1.9 1.9 0 0 1-1.198-.784 1.84 1.84 0 0 1-.317-1.025 1.8 1.8 0 0 1 .317-1.025 1.85 1.85 0 0 1 .845-.679 1.9 1.9 0 0 1 1.088-.105 1.9 1.9 0 0 1 1.198.784 1.83 1.83 0 0 1 .317 1.025M25.75 26.294l-.027-.001z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7B83EB",
    d: "M22.665 14.683a2.62 2.62 0 0 1-.461 1.49 2.7 2.7 0 0 1-.756.74 2.8 2.8 0 0 1-.987.4 2.8 2.8 0 0 1-2.056-.4 2.7 2.7 0 0 1-1.008-1.204 2.63 2.63 0 0 1 .253-2.517 2.7 2.7 0 0 1 .755-.74 2.8 2.8 0 0 1 .987-.4 2.8 2.8 0 0 1 2.056.4 2.7 2.7 0 0 1 1.009 1.204 2.6 2.6 0 0 1 .208 1.026M24.263 18.371h-7.987a.8.8 0 0 0-.736.477.8.8 0 0 0-.062.297v4.643a4.6 4.6 0 0 0 .38 1.78 4.65 4.65 0 0 0 1.042 1.506 4.8 4.8 0 0 0 1.548 1.004 4.9 4.9 0 0 0 1.822.353 4.9 4.9 0 0 0 2.646-.78 4.8 4.8 0 0 0 1.32-1.28 4.7 4.7 0 0 0 .725-1.675q.096-.45.101-.908v-4.643a.76.76 0 0 0-.236-.549.8.8 0 0 0-.563-.225"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M19.928 18.371v6.931a.6.6 0 0 1-.014.134.76.76 0 0 1-.27.465.8.8 0 0 1-.514.183h-3.023a4 4 0 0 1-.18-.336 4.472 4.472 0 0 1-.448-1.962v-4.64a.76.76 0 0 1 .233-.55.8.8 0 0 1 .563-.225zM19.927 16.47v.896a2.778 2.778 0 0 1-1.67-.557 2.7 2.7 0 0 1-.87-1.12h1.742a.8.8 0 0 1 .738.482q.06.144.06.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.098,
    d: "M20.27 18.371v6.26q-.002.222-.09.426-.087.205-.247.361-.16.157-.369.242a1.2 1.2 0 0 1-.434.088h-3.204a4.472 4.472 0 0 1-.448-1.962v-4.64a.76.76 0 0 1 .234-.55.8.8 0 0 1 .563-.225zM20.269 16.47v.875a2.782 2.782 0 0 1-2.012-.537 2.7 2.7 0 0 1-.983-1.454h1.855a1.15 1.15 0 0 1 1.052.69q.087.204.088.426"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M19.928 18.371v6.26a.76.76 0 0 1-.234.553.8.8 0 0 1-.564.229h-3.351a4.5 4.5 0 0 1-.301-1.626v-4.641a.76.76 0 0 1 .234-.55.8.8 0 0 1 .563-.225zM19.927 16.47v.896a2.778 2.778 0 0 1-1.67-.557 2.7 2.7 0 0 1-.87-1.12h1.742a.8.8 0 0 1 .738.482q.06.144.06.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.098,
    d: "M19.585 16.47v.876a2.8 2.8 0 0 1-1.328-.537 2.7 2.7 0 0 1-.87-1.12h1.4a.8.8 0 0 1 .738.482q.06.144.06.3M16.275 18.371h3.31v6.26a.76.76 0 0 1-.233.553.8.8 0 0 1-.564.229h-3.01a4.5 4.5 0 0 1-.3-1.626v-4.641a.76.76 0 0 1 .234-.55.8.8 0 0 1 .563-.225"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B53BC",
    d: "M10.799 15.69h7.987a.8.8 0 0 1 .738.482q.06.144.06.3v7.824a.76.76 0 0 1-.234.553.8.8 0 0 1-.564.229h-7.987a.81.81 0 0 1-.738-.483.8.8 0 0 1-.061-.3v-7.823a.76.76 0 0 1 .234-.554.8.8 0 0 1 .565-.229"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.849 18.549h-1.563v4.368h-.995v-4.368h-1.556V17.7h4.114z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2306_173568",
    width: 38.83,
    height: 42.685,
    x: 0.219,
    y: 0.113,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2306_173568"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2306_173568",
    result: "shape"
  })))));
};
export default SvgMt1;